import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, from, throwError } from 'rxjs';
import { AuthService } from '@fluxonos/features/user/services/auth.service';
import { isString } from 'class-validator';
import { RequestMethodEnum } from '@fluxonos/fluxonos-dto';
import { MessageService } from 'primeng/api';

export function requestErrorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): any {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);

  const hideErrorMessage =
    request.headers.get('hideErrorMessage') ||
    request.headers.get('hideerrormessage') ||
    request.headers.get('hide-error-message');

  return next(request).pipe(
    catchError((error) => {
      if (error.status !== 401 && hideErrorMessage !== 'true' && hideErrorMessage !== '1') {
        if (isString(error.error)) {
          try {
            error.error = JSON.parse(error.error);
          } catch (e) {}
        }
        if (!(request.method.toUpperCase() === RequestMethodEnum.GET)) {
          if (error.error?.description === 'UnAuthorized') {
            authService.cleanUp();
            from(router.navigate(['/', 'user', 'sign-in'])).subscribe();
          } else {
            messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message,
              life: 5000
            });
          }
        }
      }

      return throwError(() => error);
    })
  );
}
